import Indicator, { IndicatorType } from '../types/Indicator'

const Stochastic: Indicator = {
  type: IndicatorType.OSCILLATOR,
  value: 'stochastic',
  label: 'Stochastics (Simple)',
  nickname: 'Stochastics',
  fields: ['k', 'd'],
  params: {
    period: 14,
    field: 'Close',
    smooth: true,
  },
}

export default Stochastic
